import MasonryLayout from 'masonry-layout';
import ImagesLoaded from 'imagesloaded';
import lozad from 'lozad';
import facultyInitial from './facultyInitial.js';
import inView from 'in-view';
import Chart from 'chart.js';
import SmoothScroll from 'smooth-scroll';
import $ from 'jquery';
import 'slick-carousel';

export default () => {

        /**
     * メニューのリンクマッチ処理
     * @param element
     */
        const linkMatch = (element) => {
            const links = element.querySelectorAll('.js-link-match-item');
            let targetLink;
            let currentDiff = 99999;
            [].forEach.call(links, (link) => {
                link.classList.remove('is-active');
                let href = link.getAttribute('href') || link.getAttribute('data-href');
                if(href) {
                    href = href.replace("?htmx=true", "");
                }
                if (window.location.href.indexOf(href) !== -1) {
                    const diff = Math.abs(window.location.href.length - href.length);
                    if (currentDiff > diff) {
                        targetLink = link;
                        currentDiff = diff;
                    }

                }
            });
            if (targetLink) {
                targetLink.classList.add('is-active');
                if (!targetLink.classList.contains('js-link-match-parent')) {
                    const parent = targetLink.closest('.js-link-match');
                    const parentLink = parent.querySelector('.js-link-match-parent');
                    if (parentLink) {
                        parentLink.classList.add('is-active');
                    }
                }
            }

            /* Touchデバイスの場合は、メインメニューのリンクを無効化 */
            if (window.ontouchstart === null) {
                const touchDevice = element.querySelectorAll('.is-touch-device');
                const mainMenuLink = element.querySelectorAll('.js-link-match-parent');
                [].forEach.call(touchDevice, (elm) => {
                    elm.style.display = 'block';
                });
                [].forEach.call(mainMenuLink, (elm) => {
                    elm.addEventListener('click', (e) => {
                        e.preventDefault();
                    });
                });
            }
        };
        const navigation = document.querySelector('.p-navigation');
        if (navigation) {
            linkMatch(navigation);
        }

        const offcanvas = document.querySelector('.p-offcanvas');
        if (offcanvas) {
            linkMatch(offcanvas);
        }

        if (window.innerWidth >= 1024) { // $breakpoint-lg-min
            /**
             * アップロード動画背景
             * https://codepen.io/rishabhp/pen/MyMGVG
             */
            if (document.querySelector('.js-bideo')) {
                const video = document.querySelector('.js-bideo')
                const container = document.querySelector('.js-bideo-container');

                const setVideoDimensions = function () {
                    // Video's intrinsic dimensions
                    let w = video.videoWidth
                    let h = video.videoHeight;

                    // Intrinsic Ratio
                    // Will be more than 1 if W > H and less if W < H
                    var videoRatio = (w / h).toFixed(2);

                    // Get the container's computed styles
                    //
                    // Also calculate the min dimensions required (this will be
                    // the container dimentions)
                    let containerStyles = window.getComputedStyle(container)
                    var minW = parseInt(containerStyles.getPropertyValue('width'))
                    var minH = parseInt(containerStyles.getPropertyValue('height'));

                    // What's the min:intrinsic dimensions
                    //
                    // The idea is to get which of the container dimension
                    // has a higher value when compared with the equivalents
                    // of the video. Imagine a 1200x700 container and
                    // 1000x500 video. Then in order to find the right balance
                    // and do minimum scaling, we have to find the dimension
                    // with higher ratio.
                    //
                    // Ex: 1200/1000 = 1.2 and 700/500 = 1.4 - So it is best to
                    // scale 500 to 700 and then calculate what should be the
                    // right width. If we scale 1000 to 1200 then the height
                    // will become 600 proportionately.
                    let widthRatio = minW / w
                    let heightRatio = minH / h;

                    // Whichever ratio is more, the scaling
                    // has to be done over that dimension
                    if (widthRatio > heightRatio) {
                        var newWidth = minW;
                        var newHeight = Math.ceil(newWidth / videoRatio);
                    }
                    else {
                        var newHeight = minH;
                        var newWidth = Math.ceil(newHeight * videoRatio);
                    }

                    video.style.width = newWidth + 'px';
                    video.style.height = newHeight + 'px';
                };

                video.addEventListener('loadedmetadata', setVideoDimensions, false);
                window.addEventListener('resize', setVideoDimensions, false);
            }
        }

        /**
         * 教員
         */
        if (document.querySelector('.js-faculty-box')) {
            const facultyInitialSort = new facultyInitial();
        }

        /**
         * スライダー | 画像のみ
         */
        if (document.querySelector('.js-banner-slider')) {
            $('.js-banner-slider').not('.slick-initialized').slick({
                lazyLoad: 'ondemand',
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true,
                arrows: true,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 1,
                responsive: [{
                    breakpoint: 767, //$breakpoint-sm-max
                    settings: {
                        centerPadding: '35px',
                    }
                }]
            });
        }

        /**
         * スライダー | 画像+テキスト
         */
        if (document.querySelector('.js-not-center-mode-banner-slider')) {
            $('.js-not-center-mode-banner-slider').not('.slick-initialized').slick({
                lazyLoad: 'ondemand',
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true,
                arrows: true,
                centerMode: true,
                ccenterPadding: '60px',
                slidesToShow: 1,
                responsive: [{
                    breakpoint: 767, //$breakpoint-sm-max
                    settings: {
                        centerMode: false,
                        centerPadding: '0',
                    }
                }]
            });
        }

        /**
         * toggle ページロード時開いてる状態
         */
        $('.js-toggle-nucb-head').on("click", function () {
            $this = $(this);
            $this.next('.js-toggle-nucb-body').slideToggle(500, 'swing');
            $this.toggleClass('is-closed');
        });

        /**
         * pinterest風レイアウト
         */
        let masonry = null;
        const reloadMasonryLayout = (masonry) => {
            if (masonry) {
                masonry.destroy();
            }
            const containers = document.querySelectorAll('.js-images-loaded-container');
            containers.forEach((container) => {
                const images = container.querySelectorAll('img');
                [].forEach.call(images, (img) => {
                    const src = img.getAttribute('data-src');
                    if (src) {
                        img.setAttribute('src', src);
                    }
                });
                ImagesLoaded(container, () => {
                    const grid = container.querySelector('.js-masonry-grid');
                    if (grid) {
                        masonry = new MasonryLayout(grid, {
                            itemSelector: '.js-masonry-grid-item'
                        });
                        setTimeout(() => {
                            const moreLoad = lozad('.js-change-contents', {
                                loaded: (container) => {
                                    const nextForm = container.querySelector('.js-masonry-submit');
                                    nextForm.click();
                                }
                            });
                            moreLoad.observe();
                        }, 500);
                    }
                });
            });
        };
        reloadMasonryLayout(masonry);

        ACMS.addListener('acmsAfterPostInclude', () => {
            reloadMasonryLayout(masonry);
            htmx.process(document.body);
        });


        /**
     * グラフユニットの描写
     */
        $('canvas').each(function () {
            var id = $(this).attr('id');
            var ctx = $(this).get(0).getContext('2d');
            var $template = $(this).next();
            var option = JSON.parse($template.html());
            inView('#' + id).once('enter', function () {
                new Chart(ctx, option);
            });
        });


        ACMS.Ready(() => {
            /**
             * 内部リンクのスムーススクロール
             */
            // const scroll = new SmoothScroll('.js-smooth-scroll-to', {
            //     speed: 800,
            //     speedAsDuration: true,
            //     easing: 'easeInOutCubic',
            //     offset: window.innerWidth >= 1024 ? $('.js-scroll-height-pc').height() + 25 : $('.js-scroll-height-sp').height() + 25,
            // });

            /**
             * エフェクトなしポストインクルード用
             */
            ACMS.Config.postIncludeArray.push({
                'mark': '.js-post_include-no-effect',
                'type': 'submit',
                'method': 'replace',
                'effect': '',
            });
        });

        /**
         * グラフユニットの切り替え設定
         */
        var setView = function (type, target) {
            if (type === 'bar') {
                $('.chart_labels_num-js', target).hide();
                $('.chart_labels_chara-js', target).show();
                $('.chart_color_bk-js', target).show();
                $('.chart_color_frame-js', target).hide();
                $('.chart_color_single-js', target).hide();
                $('.chart_color_multi-js', target).show();
                $('.chart_data_single-js', target).hide();
                $('.chart_data_multi-js', target).show();
            } else if (type === 'line') {
                $('.chart_labels_chara-js', target).hide();
                $('.chart_labels_num-js', target).show();
                $('.chart_color_frame-js', target).show();
                $('.chart_color_bk-js', target).hide();
                $('.chart_color_multi-js', target).hide();
                $('.chart_color_single-js', target).show();
                $('.chart_data_single-js', target).hide();
                $('.chart_data_multi-js', target).show();
            } else {
                $('.chart_labels_chara-js', target).hide();
                $('.chart_labels_num-js', target).hide();
                $('.chart_color_bk-js', target).show();
                $('.chart_color_frame-js', target).hide();
                $('.chart_color_multi-js', target).hide();
                $('.chart_color_single-js', target).show();
                $('.chart_data_multi-js', target).hide();
                $('.chart_data_single-js', target).show();
            }
        }

        ACMS.addListener('acmsAddUnit', function (event) {
            var target = event.target;
            var $type = $('.chart_type-js', event.target);
            var type = $type.val();
            setView(type, target);
            $('.chart_type-js', target).change(function (e) {
                var type = e.target.value;
                setView(type, target);
            });
        });

        ACMS.addListener("acmsAddCustomFieldGroup", function (event) {
            var target = event.target;
            var parent = $(target).parents('.js-ajax_upload_image_box');
            var $type = $('.chart_type-js', parent);
            var type = $type.val();
            setView(type, parent);
        });


}
